import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ImportationsComponent } from './import-portefeuilles/importations/importations.component';
import { ImportationDetailsComponent } from './import-portefeuilles/importation-details/importation-details.component';
import { PortefeuilleDetailsComponent } from './portefeuilles/portefeuille-details/portefeuille-details.component';
import { PortefeuillesComponent } from './portefeuilles/portefeuilles.component';
import { ParametreNotationComponent } from './parametres/parametre-notation/parametre-notation.component';
import { ParametreEntityPondereeComponent } from './parametres/parametre-entity-ponderee/parametre-entity-ponderee.component';
import { ParametrePondereComponent } from './parametres/parametre-pondere/parametre-pondere.component';
import { TypeFinancementComponent } from './parametres/type-financement/type-financement.component';
import { TypeGarantieComponent } from './parametres/type-garantie/type-garantie.component';
import { RuleManagementComponent } from './parametres/rule-management/rule-management.component';
import { SegmentationPrudentielleComponent } from './parametres/segmentation-prudentielle/segmentation-prudentielle.component';
import { ParametreGeneralComponent } from './parametres/parametre-general/parametre-general.component';

const routes: Routes = [
  
  {
    path: '',
    data: {breadcrumb: 'Fonds propres '},
    children: [
        {
          path:'',
          redirectTo: 'importations',
          pathMatch: 'full' 
       },
       {
        path: 'importations',
        component: ImportationsComponent,
        data: {breadcrumb: 'Importations'},
        },
        {
          path: 'importation-details/:importPortefeuilleId',
          component: ImportationDetailsComponent,
          data: {breadcrumb: 'Détail importation'},
          }
    ]
  },
  {
    path: 'portefeuilles',
    data: {breadcrumb: 'Fonds propres '},
    children: [
        {
          path:'',
          redirectTo: 'portefeuille-details',
          pathMatch: 'full' 
       },
        {
          path: 'portefeuille-details',
          component: PortefeuilleDetailsComponent,
          data: {breadcrumb: 'Détails portefeuille'},
          },
        {
          path: 'portefeuilles',
          component: PortefeuillesComponent,
          data: {breadcrumb: 'Portefeuilles'},
      }
    ]
  },
  {
    path: 'parametres',
    data: {breadcrumb: 'Fonds propres paramètres '},
    children: [
        {
          path:'',
          redirectTo: 'parametre-notation',
          pathMatch: 'full' 
       },
      {
        path: 'parametre-notation',
        component: ParametreNotationComponent,
        data: {breadcrumb: 'Paramètre notation'},
      },
      {
        path: 'entity-ponderee',
        component: ParametreEntityPondereeComponent,
        data: {breadcrumb: 'Entité pondérée'},
      },
      {
        path: 'parametre-pondere',
        component: ParametrePondereComponent,
        data: {breadcrumb: 'Paramètre pondéré'},
      },
      {
        path: 'type-financement',
        component: TypeFinancementComponent,
        data: {breadcrumb: 'Type financement'},
      },
      {
        path: 'type-garantie',
        component: TypeGarantieComponent,
        data: {breadcrumb: 'Type garantie'},
      },
      {
        path: 'rule-management',
        component: RuleManagementComponent,
        data: {breadcrumb: 'Gestion de règles'},
      },
      {
        path: 'segmentations-prudentielles',
        component: SegmentationPrudentielleComponent,
        data: {breadcrumb: 'Segmentations prudentielles'},
      },
      {
        path: 'parametre-general',
        component: ParametreGeneralComponent,
        data: {breadcrumb: 'Paramètres généraux'},
      }
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FondsPropresRoutingModule { }